module.exports = __webpack_public_path__ + "img/banner_info.16cd6cf8.png";